<template>
  <div class="pro-content">
    <div class="shop_product">
      <h3 class="shop_product_title">{{type == '0' ? '猜你喜欢' : '热销单品推荐'}}</h3>
      <div class="clearFix">
        <div class="mobile-product-list2" style="padding: 0;" v-if="url">
          <div :style="{ backgroundImage : 'url(' + url + ')', backgroundSize : 'cover', backgroundRepeat : 'no-repeat', width: '100%', height: isLogin ? '255px' : '303px' }"></div>
        </div>
        <div v-for="(slide, index) in data" :key="index" class="mobile-product-list2">
          <router-link @click.native="toProduct(slide.id)" :to="`/product-detail?id=${slide.id}`">
            <img :src="slide.pic" />
            <div class="product-content">
              <p class="product-name" :title="slide.name">{{ slide.name }}</p>
              <div class="price" v-if="isLogin">
                <span>￥<em>{{ slide.price | moneyFilters }}</em></span>
                <span class="crossedPrice" v-if="slide.crossedPrice!=slide.price">￥<em>{{ slide.crossedPrice | moneyFilters }}</em></span>
              </div>
              <div class="price" v-else>
                <span class="tips">官方建议零售价：￥<em>{{ slide.crossedPrice | moneyFilters }}</em></span>
                <!-- <p class="tips">登录/注册会员即可享受会员价</p> -->
                <Tip></Tip>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/js/swiper'
import 'swiper/css/swiper.css'
import Tip from '@/components/Tip'
export default {
  name: 'ProductMobile',
  props: ['data', 'type', 'url'],
  components: {
    Tip
  },
  data () {
    return {
      isLogin: this.$store.getters.status,
      swiper: null
    }
  },
  // watch: {
  //   'data' (val) {
  //     let t = setTimeout(() => {
  //       this.initSwiper()
  //       clearTimeout(t)
  //     }, 50)
  //   }
  // },
  methods: {
    toProduct(id) {
      philips.analytics.trackConversion ({ 
        name:"prodview",
        products: id
      })
    },
    initSwiper () {
      this.swiper = new Swiper('.swiper-container', {
        initialSlide: 0, // 初始显示第1个
        spaceBetween: 10,
        loop: false,
        observer: true,
        observeParents: true
      })
    },
    toDetail (val) {
      this.$router.push(`/product-detail?id=${val.id}`)
    }
  },
  destroyed () {
    this.swiper = null
  }
}
</script>

<style lang="scss" scoped>
  .pro-content {
    .shop_product_title {
      padding: 20px 0;
    }
    .mobile-product-list {
      width: 150px !important;
      background: #fff;
      padding: 10px;
      box-sizing: border-box;
      img {
        max-width: 100%;
        height: 150px;
        margin: 0 auto;
        display: block;
      }
    }
    .mobile-product-list2 {
      background: #fff;
      padding: 10px;
      width: calc(50% - 5px);
      float: left;
      box-sizing: border-box;
      margin-bottom: 10px;
      margin-right: 10px;
      img {
        max-width: 100%;
        height: 150px;
        margin: 0 auto;
        display: block;
      }
    }
    .mobile-product-list2:nth-child(2n) {
      margin-right: 0;
    }
    .product-name {
      height: 36px;
      font-size: 14px;
      margin: 5px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MobileIndex.vue